import { Outlet } from 'react-router-dom'
import { setAxiosAccountContext } from '@/utils/axios.js'
import { useCurrentAccount } from '@/hooks/useCurrentAccount.jsx'

export default function AccountGuard() {

    const { account } = useCurrentAccount()

    if (!account) {
        // User try to access non-existing account, meaning he doesn't have access to it
        console.log('No Account?')
        return
    }

    // Not in use - if we need initialization page, we can add it here
    // if (account.isInitializing) {
    //     return <InitializingPage />
    // }

    setAxiosAccountContext(account._id)

    return <Outlet />
}